const mediaItems = [
  {
    title: '深度解读：51cg平台生态与发展历程',
    source: '行业观察',
    date: '2026.07',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20with%20abstract%20digital%20ecosystem%20concept%2C%20warm%20golden%20and%20cream%20tones%2C%20geometric%20layered%20composition%2C%20minimalist%20professional%20design%2C%20soft%20ambient%20lighting%2C%20no%20text&width=800&height=450&seq=media-01-51cg&orientation=landscape',
  },
  {
    title: '网址导航对用户访问体验的价值分析',
    source: '产品研究',
    date: '2026.06',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20user%20experience%20and%20navigation%20concept%20with%20flowing%20pathways%2C%20warm%20coral%20and%20gold%20accents%2C%20cream%20background%2C%20minimalist%20clean%20editorial%20style%2C%20no%20text%20or%20labels&width=800&height=450&seq=media-02-51cg&orientation=landscape',
  },
  {
    title: '51cg社区活跃度持续增长的背后逻辑',
    source: '社区洞察',
    date: '2026.05',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20growth%20chart%20and%20community%20concept%20with%20rising%20organic%20shapes%2C%20warm%20amber%20and%20sage%20green%20highlights%2C%20cream%20background%2C%20minimalist%20design%2C%20no%20text&width=800&height=450&seq=media-03-51cg&orientation=landscape',
  },
  {
    title: '内容平台域名安全管理最佳实践',
    source: '安全专刊',
    date: '2026.04',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cybersecurity%20and%20protection%20shield%20concept%20with%20geometric%20layers%2C%20warm%20gold%20and%20coral%20accents%2C%20cream%20background%2C%20minimalist%20editorial%20style%2C%20no%20text&width=800&height=450&seq=media-04-51cg&orientation=landscape',
  },
  {
    title: '从51cg看信息聚合平台的演进趋势',
    source: '趋势报告',
    date: '2026.03',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20future%20trend%20and%20evolution%20visualization%20with%20flowing%20data%20streams%2C%20warm%20coral%20and%20golden%20highlights%2C%20cream%20background%2C%20minimalist%20clean%20design%2C%20no%20text&width=800&height=450&seq=media-05-51cg&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">媒体聚焦</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">有关51cg平台的专题报道与分析文章精选</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-foreground-700 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-secondary-50 text-secondary-700 font-medium whitespace-nowrap">
                    {item.source}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}